export default {
  methods: {
    bindEscape() {
      document.addEventListener('keydown', this._handleEscape);
    },
    unbindEscape() {
      document.removeEventListener('keydown', this._handleEscape);
    },
    _handleEscape(e) {
      if (
        (e.key === 'Escape' || e.keyCode === 27) &&
        typeof this.handleEscape === 'function'
      ) {
        this.handleEscape();
      }
    },
  },
  mounted() {
    this.bindEscape();
  },
  beforeDestroy() {
    this.unbindEscape();
  },
};
